import { render, staticRenderFns } from "./MyCampaigns.vue?vue&type=template&id=4666ca80&scoped=true"
import script from "./MyCampaigns.vue?vue&type=script&lang=ts"
export * from "./MyCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./MyCampaigns.vue?vue&type=style&index=0&id=4666ca80&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4666ca80",
  null
  
)

export default component.exports